// extracted by mini-css-extract-plugin
export default {"tos":"TermsLinks_tos__xvkTv"};